<template>
  <section class="c loading">
    <div class="overlay" v-show="isLoading">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
  </section>
</template>

<script>
export default {
  name: 'loading',

  computed: {
    isLoading() {
      return this.$store.app.state.isLoading;
    },
  },
};
</script>
